module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "systemTypeBloc"
  }, [_c('SystemTypeIcon', {
    attrs: {
      "type": _vm.systemTypeId
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t(("systemTypes." + _vm.systemTypeId))))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4628f0aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/config/carcass/components/system-type-item.vue
// module id = 3155
// module chunks = 0